import Vue from 'vue';
import VueRouter from 'vue-router';
import PluginVuex from '@/plugins/vuex';
import vuetify from '@/plugins/vuetify';
import Routes from '@/routes';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: Routes,
	scrollBehavior(to, from, savedPosition)
	{
		if(savedPosition)
		{
			return savedPosition;
		}

		if(to.hash)
		{
			return {
				selector: to.hash,
				behavior: 'smooth',
				offset: {
					x: 0,
					y: 64
				}
			}
		}

		return {
			x: 0,
			y: 0
		};
	}
});

/**
 * meta.theme === 'light' 인 라우트(건설사 랜딩)는 라이트 모드로 고정.
 * colorScheme 선언으로 모바일 브라우저의 강제 다크모드에서도 제외.
 */
router.beforeEach((to, from, next) => {
	const isLight = to.meta && to.meta.theme === 'light';

	vuetify.framework.theme.dark = !isLight;
	if(isLight)
	{
		document.documentElement.style.setProperty('color-scheme', 'light');
	}
	else
	{
		document.documentElement.style.removeProperty('color-scheme');
	}

	next();
});

router.onError((e: Error) => {
	if(e.name === 'ChunkLoadError')
	{
		PluginVuex.commit('common/SET_DIALOG', {
			status: 'WARNING',
			content: '시스템 파일이 변경되어 페이지 새로고침을 진행합니다.<br />이 후에도 같은 메세지가 나타난다면 강제 새로고침을 해주세요.',
			confirm: async () => {
				window.location.reload();
			}
		});
	}
});

export default router;